import React from 'react';
import { Link } from 'react-router-dom';
import ProductList from './ProductList';
import styles from './ProductsPage.module.css';

const ProductsPage: React.FC = () => {
  return (
    <div className={styles.productsPage}>
      {/* Products Section */}
      <section className={styles.productsSection}>
        <div className={styles.productsContainer}>
          <div className={styles.productsGrid}>
            <ProductList />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={styles.ctaSection}>
        <div className={styles.ctaContainer}>
          <h2 className={styles.ctaTitle}>Questions About Our Products?</h2>
          <p className={styles.ctaText}>
            Need help choosing the right size or have questions about our
            made-to-order process?
          </p>
          <div className={styles.ctaButtons}>
            <Link to="/contact" className={styles.ctaButton}>
              Contact Us
            </Link>
            <Link to="/shipping-policy" className={styles.ctaButtonSecondary}>
              Shipping Info
            </Link>
          </div>
        </div>
      </section>

      {/* Back to Home */}
      <div className={styles.backToHome}>
        <Link to="/" className={styles.backToHomeButton}>
          <svg
            className={styles.backToHomeIcon}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          <span>Back to Home</span>
        </Link>
      </div>
    </div>
  );
};

export default ProductsPage;
